import { mapActions } from 'vuex';
import StarsRating from './stars-rating/component.vue';

export default {
  name: 'page-call-end',
  props: ['widgetStyle', 'canSendFeedbackAfterConversation', 'widgetConfig'],
  components: {
    'stars-rating': StarsRating,
  },
  data() {
    return {
      feedbackParams: {},
    };
  },
  computed: {
    style() {
      return {
        backgroundColor: this.widgetStyle.main_color,
        borderColor: this.widgetStyle.main_color,
      };
    },
  },
  created() {
    this.$root.$on('setFeedbak', params => this.handleSetFeedback(params));
  },
  beforeDestroy() {
    this.$root.$off('setFeedbak');
  },
  methods: {
    ...mapActions(['toggleWidgetModal', 'resetStatus', 'sendFeedbackAfterConversation']),
    handleSetFeedback(params) {
      this.feedbackParams = params;
    },
    closeModalAndResetStatus() {
      if (this.feedbackParams.rating) {
        this.sendFeedbackAfterConversation(this.feedbackParams);
      }

      this.toggleWidgetModal();
      this.resetStatus();
    },
  },
};
